module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Fb-Ga-Hc-Ia.2c682f25.png";